var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 14.6667C12.1821 14.6667 15.1668 11.6819 15.1668 8.00004C15.1668 4.31814 12.1821 1.33337 8.50016 1.33337C4.81826 1.33337 1.8335 4.31814 1.8335 8.00004C1.8335 11.6819 4.81826 14.6667 8.50016 14.6667Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 8H10.6857M9.16683 6L11.1668 8L9.16683 10",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateout);
export default __webpack_public_path__ + "static/media/gateout.d6b866e83f21a1fe0102a04850af2afc.svg";
export { ForwardRef as ReactComponent };